import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Award, Heart, Star, Users } from 'lucide-react';
const staff = [{
  name: 'Master Danielle Schell',
  title: 'Master Instructor & Owner',
  rank: '5th Degree Black Belt',
  experience: '21 years',
  highlights: ['Kickpics Spokesperson 2015', 'National Champion 2013/2015', '6x Gold State Champion', '3rd Degree Black Belt in Karate', 'Teaching for 17 years', 'Michigan Sport Taekwondo Treasurer', 'Kukkiwon Certified', 'First Aid Certified since 2013', 'Owner since 2015'],
  image: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1645477835190-TQR4HNUH1PEW98DTKC2B/13962744_596384953864661_6136132398074271172_n.jpg'
}, {
  name: 'Joyce Barsaleau',
  title: 'Instructor',
  rank: '2nd Degree Black Belt',
  experience: '5 years',
  highlights: ['First Aid/CPR Certified', 'Mom to 5 beautiful girls'],
  image: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1649720236673-GIYDDOHPLRHQTDUBUT95/CBC_Staff_2021-127.jpeg'
}, {
  name: 'Brinna Barsaleau',
  title: 'Instructor',
  rank: '2nd Degree Black Belt',
  experience: '5 years',
  highlights: ['Teaching for 5 years', 'Competitive Sparring Team for 5 years', 'Ohio State Champion 2022', 'Michigan State Champion - 3 years', 'Lead Instructor for Intro Sparring Class', 'Plays the flute in school band'],
  image: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1649726379002-BFAYSESAGD5SOYNXBV55/IMG_1986.JPG'
}, {
  name: 'Katie Staron',
  title: 'Instructor',
  rank: '3rd Degree Black Belt',
  experience: '8 years',
  highlights: ['Teaching for 5 years', 'Kukkiwon Certified', 'Psychology Professor', 'Clinical Psychologist - Owns her own practice'],
  image: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1705531721361-9AP3N8KMY91ON9XBDKFT/IMG_2461.JPG'
}, {
  name: 'Joseph Schell',
  title: 'Instructor',
  rank: '3rd Degree Black Belt',
  experience: '9 years',
  highlights: ['Teaching for 6 years', 'Kukkiwon Certified', "Bachelor's degree in Culinary Dietary Operations and Management"],
  image: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1705532174833-Y3YNER46QN8YFCXRPDCM/IMG_0709-2.jpg'
}, {
  name: 'Ms. Sophia Clemons',
  title: 'Instructor',
  rank: '2nd Degree Black Belt',
  experience: '6 years',
  highlights: ['Teaching for 2 years', 'Forms State Champion', 'National Competitor'],
  image: 'https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/1711485645073-QXV2Z8Q07EZEJO7F5GEM/428614179_10228664638894092_1879145699102955651_n.jpg'
}];
const values = [{
  icon: Heart,
  title: 'Student-Centered',
  description: 'Every student receives personalized attention and encouragement to reach their full potential.'
}, {
  icon: Star,
  title: 'Excellence',
  description: 'Our instructors maintain the highest standards of technical skill and teaching ability.'
}, {
  icon: Users,
  title: 'Community',
  description: 'We foster a supportive environment where students and families grow together.'
}, {
  icon: Award,
  title: 'Certified',
  description: 'All instructors are certified through Kukkiwon (World Taekwondo Headquarters).'
}];
export function StaffPage() {
  return <main className="pt-40 pb-20 bg-gray-50" data-id="element-595">
      <div className="bg-primary text-white py-16 mb-12" data-id="element-596">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-597">
          <Users className="w-16 h-16 mx-auto mb-6 text-gold" data-id="element-598" />
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-599">Meet Our Team</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto" data-id="element-600">
            Our experienced, certified instructors are dedicated to helping you
            achieve your martial arts goals.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-601">
        {/* Values */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-602">
          {values.map(value => <Card key={value.title} className="p-6 text-center" data-id="element-603">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-604">
                <value.icon className="w-6 h-6 text-primary" data-id="element-605" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-606">{value.title}</h3>
              <p className="text-sm text-gray-600" data-id="element-607">{value.description}</p>
            </Card>)}
        </div>

        {/* Staff Profiles */}
        <div className="space-y-8 mb-16" data-id="element-608">
          {staff.map((member, index) => <Card key={member.name} className="overflow-hidden" data-id="element-609">
              <div className={`grid grid-cols-1 md:grid-cols-3 gap-0 ${index % 2 === 1 ? 'md:grid-flow-dense' : ''}`} data-id="element-610">
                <div className={`p-8 md:p-12 flex flex-col justify-center ${index % 2 === 1 ? 'md:col-start-2 md:col-span-2' : 'md:col-span-2'}`} data-id="element-611">
                  <div className="flex items-start justify-between mb-4" data-id="element-612">
                    <div data-id="element-613">
                      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-1" data-id="element-614">
                        {member.name}
                      </h2>
                      <p className="text-primary font-semibold mb-2" data-id="element-615">
                        {member.title}
                      </p>
                    </div>
                    <div className="text-right" data-id="element-616">
                      <div className="bg-gold/10 text-gold px-3 py-1 rounded-full text-sm font-semibold mb-1" data-id="element-617">
                        {member.rank}
                      </div>
                      <p className="text-xs text-gray-500" data-id="element-618">
                        {member.experience} experience
                      </p>
                    </div>
                  </div>

                  <div data-id="element-619">
                    <h4 className="font-semibold text-gray-900 mb-3" data-id="element-620">
                      Highlights:
                    </h4>
                    <ul className="space-y-2" data-id="element-621">
                      {member.highlights.map((highlight, idx) => <li key={idx} className="flex items-start text-gray-600 text-sm" data-id="element-622">
                          <span className="text-primary mr-2" data-id="element-623">•</span>
                          <span data-id="element-624">{highlight}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>

                <div className={`h-64 md:h-auto ${index % 2 === 1 ? 'md:col-start-1 md:row-start-1' : ''}`} data-id="element-625">
                  <div className="w-full h-full overflow-hidden" data-id="element-626">
                    <img src={member.image} alt={member.name} className="w-full h-full object-cover" data-id="element-627" />
                  </div>
                </div>
              </div>
            </Card>)}
        </div>

        {/* CTA */}
        <div className="bg-primary rounded-2xl p-8 md:p-12 text-center text-white shadow-sm" data-id="element-628">
          <h2 className="text-3xl font-bold mb-4" data-id="element-629">Train with the Best</h2>
          <p className="text-white mb-8 max-w-2xl mx-auto" data-id="element-630">
            Experience the difference that expert, caring instruction makes.
            Start your journey with our 4-week trial.
          </p>
          <Link to="/trial" data-id="element-631">
            <Button size="lg" className="bg-accent hover:bg-accent-dark text-white border-none" data-id="element-632">
              Start Your 4-Week Trial
            </Button>
          </Link>
        </div>
      </div>
    </main>;
}